import AuthController from "./AuthController";


function Exporter() {
    return (
        <AuthController />
    );
}

export default Exporter;